import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import DefaultLayout from "src/layouts"
import "./MemberPortal3.scss"

// Import banner images
import Banner from "./images/pv-checkin-hero-desktop.jpg"

// Import images for the access section
import Banner1 from "./images/BANNER 1.jpg"
import Banner2 from "./images/BANNER 2.jpg"
import Banner3 from "./images/BANNER 3.jpg"
import Banner4 from "./images/BANNER 4.jpg"
import Image1 from "./images/IMAGE 1.png"
import Image2 from "./images/IMAGE 2.png"
import Image3 from "./images/IMAGE 3.png"
import Image4 from "./images/IMAGE 4.png"
import Gif1 from "./images/gif-1.gif";
import Gif2 from "./images/gif-2.gif";
import Logo from "./images/logoppv.svg";

// Import mobile assets
import MobileHeroBanner from "./images/mobile/pv-checkin-hero-mobile.jpg"
import MobileBanner1 from "./images/mobile/BANNER 1.jpg"
import MobileBanner2 from "./images/mobile/BANNER 2.jpg"
import MobileBanner3 from "./images/mobile/BANNER 3.jpg"
import MobileBanner4 from "./images/mobile/BANNER 4.jpg"
import MobileGif1 from "./images/mobile/gif-1.gif"
import MobileGif2 from "./images/mobile/gif-2.gif"
import MobileImg0 from "./images/mobile/IMG 0.jpg"
import MobileImg1 from "./images/mobile/IMG 1.png"
import MobileImg2 from "./images/mobile/IMG 2.png"
import MobileImg3 from "./images/mobile/IMG 3.png"
import MobileImg4 from "./images/mobile/IMG 4.png"
import MobileImg5 from "./images/mobile/IMG 5.jpg"

const MemberPortal3 = () => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth)
  const navigate = useNavigate()

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth)
    }
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <DefaultLayout isHeaderFixed={true} isFooterAnimated={false} hasVideoBanner={false}>
      <section className='member-portal-page-desktop'>
        {/* Full Width Banner */}
        <div className='banner-container'>
          <div className='banner-image'>
            <img
              src={Banner}
              alt="Member Portal Banner"
              className='banner-img'
            />
          </div>
          <div className='banner-content'>
            <div className='banner-text-top'>
              <h1 className='banner-main-title'>MEMBER PORTAL 3.0</h1>
              <p className='banner-main-subtitle'>A New Era for Your Member Experience</p>
            </div>

            <div className='banner-text-bottom'>
              <p className='banner-sub-title'>
                Welcome to Member Portal 3.0 
              </p>
              <p className='banner-description'>
                The Foundation Of A Truly Elevated Member Journey<br />
              </p>
              <p className='banner-description'>More than a gateway, this reimagined platform empowers you with greater control, flexibility, and sophistication, transforming how your members discover, book, and engage with your club’s world-class services and amenities.

              </p>
             
            </div>
          </div>
        </div>

        {/* Access Made Effortless Section */}
        <div className='access-section'>
          {/* Left Navigation */}
          <div className='access-navigation'>
            <a href="#members" className='nav-link active'>FOR MEMBERS</a>
            <a href="#operators" className='nav-link'>FOR OPERATORS</a>
          </div>

          {/* Right Content Area */}
          <div className='access-content'>
            {/* Banner Section */}
            <div className='access-banner'>
              <img
                src={Banner1}
                alt="Access Made Effortless"
                className='access-banner-img'
              />
              <div className='access-banner-overlay'>
                <h2 className='access-banner-title'>ACCESS MADE EFFORTLESS</h2>
                <p className='access-banner-subtitle'>Members can now log in with Face ID – no passwords, just a glance.</p>
              </div>
            </div>

            {/* For Members Section */}
            <div className='for-members-section' id="members">
              <h3 className='section-title'>FOR MEMBERS</h3>

              <div className='content-row'>
                <div className='text-content'>
                  <div className='feature-item'>
                    <h4 className='feature-title'>RELIABLE ACCESS:</h4>
                    <p className='feature-description'>
                      Works seamlessly in most conditions, including low light or while wearing a mask.
                    </p>
                  </div>

                  <div className='feature-item'>
                    <h4 className='feature-title'>INSTANT ENTRY:</h4>
                    <p className='feature-description'>
                      Log in securely in seconds with facial recognition.
                    </p>
                  </div>

                  <div className='feature-item'>
                    <h4 className='feature-title'>ULTIMATE SECURITY:</h4>
                    <p className='feature-description'>
                      Biometric login means no passwords to remember or reset – your face is your key.
                    </p>
                  </div>
                </div>

                <div className='image-content'>
                  <img
                    src={Image1}
                    alt="Member using Face ID"
                    className='content-image'
                  />
                </div>
              </div>
            </div>

            {/* For Operators Section */}
            <div className='for-operators-section' id="operators">
              <h3 className='section-title'>FOR OPERATORS</h3>

              <div className='content-row'>
                <div className='image-content'>
                  <img
                    src={Image2}
                    alt="Operator interface"
                    className='content-image'
                  />
                </div>

                <div className='text-content'>
                  <div className='feature-item'>
                    <h4 className='feature-title'>PREMIUM EXPERIENCE:</h4>
                    <p className='feature-description'>
                      A sleek, intuitive login that meets the expectations of today's discerning members.
                    </p>
                  </div>

                  <div className='feature-item'>
                    <h4 className='feature-title'>REDUCED SUPPORT:</h4>
                    <p className='feature-description'>
                      Fewer password reset requests for your team to handle.
                    </p>
                  </div>

                  <div className='feature-item'>
                    <h4 className='feature-title'>ENHANCED PROTECTION:</h4>
                    <p className='feature-description'>
                      Biometric authentication delivers robust, modern security.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Smart Tools Section */}
        <div className='smart-tools-section'>
          {/* Banner with image and overlay text */}
          <div className='smart-tools-banner'>
            <div className='banner-image-container'>
              <img
                src={Banner2}
                alt="Smart Tools Banner"
                className='smart-tools-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='smart-tools-title'>FLEXIBLE CONTENT PRESENTATION, TAILORED TO YOUR CLUB</h2>
              </div>
            </div>
          </div>
        </div>

        {/* Directory Cards Section */}
        <div className='directory-cards-section'>
          <div className='directory-cards-container'>
            {/* Header */}
            <div className='directory-cards-header'>
              <h2 className='directory-cards-title'>YOUR CLUB IS UNIQUE, YOUR MEMBER PORTAL SHOULD REFLECT THAT.</h2>
              <p className='directory-cards-subtitle'>
                Directory Cards introduce a new content structure, giving you full control over how dining, spa, activities, and more are
                showcased. Curate experiences, link bookings, or embed forms, all with greater flexibility over layout and sequence.
              </p>
            </div>

            {/* Content Row */}
            <div className='directory-cards-content'>
              {/* Left Text Content */}
              <div className='directory-cards-text'>
                <div className='directory-card-item'>
                  <div className='directory-card-line'></div>
                  <h3 className='directory-card-heading'>INFORMATIONAL</h3>
                  <p className='directory-card-description'>Share static content, hours, and image galleries.</p>
                </div>

                <div className='directory-card-item'>
                  <div className='directory-card-line'></div>
                  <h3 className='directory-card-heading'>BOOKABLE</h3>
                  <p className='directory-card-description'>Connect members directly to one or multiple schedulers.</p>
                </div>

                <div className='directory-card-item'>
                  <div className='directory-card-line'></div>
                  <h3 className='directory-card-heading'>FORM</h3>
                  <p className='directory-card-description'>Enable easy enquiry submissions with a single form.</p>
                </div>

                <div className='directory-card-item'>
                  <div className='directory-card-line'></div>
                  <h3 className='directory-card-heading'>HYBRID</h3>
                  <p className='directory-card-description'>Combine booking and forms for multifaceted experiences.</p>
                </div>

                <div className='directory-card-item'>
                  <div className='directory-card-line'></div>
                  <h3 className='directory-card-heading'>CALL-TO-ACTION</h3>
                  <p className='directory-card-description'>Guide members seamlessly with internal or external links.</p>
                </div>
              </div>

              {/* Right Image Content */}
              <div className='directory-cards-image'>
                <img
                  src={Gif1}
                  alt="Directory Cards Interface"
                  className='directory-cards-gif'
                />
              </div>
            </div>
          </div>
        </div>

        {/* New Capabilities Section */}
        <div className='new-capabilities-section'>
          <div className='new-capabilities-container'>
            {/* Header */}
            <div className='new-capabilities-header'>
              <h2 className='new-capabilities-title'>NEW CAPABILITIES</h2>
            </div>

            {/* Centered Image */}
            <div className='new-capabilities-image-container'>
              <img
                src={Image3}
                alt="New Capabilities Interface"
                className='new-capabilities-image'
              />
            </div>

            {/* Bottom Text Content - Two Columns */}
            <div className='new-capabilities-content'>
              <div className='capability-item left'>
                <h3 className='capability-heading'>REDESIGNED HOME PAGE:</h3>
                <p className='capability-description'>
                  Aggregate your signature experiences like events, spa, dining and club benefits
                  front and center on one page.
                </p>
              </div>

              <div className='capability-item right'>
                <h3 className='capability-heading'>DIRECTORY PRIORITIZATION:</h3>
                <p className='capability-description'>
                  Control the order of your directory profiles to highlight your most important
                  offerings at the top.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Optimized Booking Banner Section */}
        <div className='optimized-booking-section'>
          {/* Banner with image and overlay text */}
          <div className='optimized-booking-banner'>
            <div className='banner-image-container'>
              <img
                src={Banner3}
                alt="Optimized Booking Banner"
                className='optimized-booking-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='optimized-booking-title'>OPTIMIZED BOOKING & EVENT MANAGEMENT</h2>
                <div className='optimized-booking-content'>
                  <h3 className='optimized-booking-subtitle'>FEWER STEPS. MORE CONFIRMATIONS.</h3>
                  <p className='optimized-booking-description'>
                    A streamlined booking drawer makes it easier for members to select time
                    slots, add guests, and complete reservations quickly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Features Section */}
        <div className='enhanced-features-section'>
          <div className='enhanced-features-container'>
            {/* Content Row - Image Left, Text Right */}
            <div className='enhanced-features-content'>
              {/* Left Image Content */}
              <div className='enhanced-features-image'>
                <img
                  src={Gif2}
                  alt="Enhanced Features Interface"
                  className='enhanced-features-gif'
                />
              </div>

              {/* Right Text Content */}
              <div className='enhanced-features-text'>
                <div className='enhanced-feature-item'>
                  <h3 className='enhanced-feature-heading'>WAITLIST VISIBILITY</h3>
                  <p className='enhanced-feature-description'>
                    When events reach capacity, members see "Join Waitlist" instead of "Sold Out."
                  </p>
                </div>

                <div className='enhanced-feature-item'>
                  <h3 className='enhanced-feature-heading'>BOOK4TIME INTEGRATION</h3>
                  <p className='enhanced-feature-description'>
                    Even when a time slot is fully booked, members can still view availability and join the waitlist – ensuring they remain engaged, even when demand is high.
                  </p>
                </div>

                <div className='enhanced-feature-item'>
                  <h3 className='enhanced-feature-heading'>ON-SALE DATES</h3>
                  <p className='enhanced-feature-description'>
                    Events with future ticket releases display their on-sale date, keeping anticipation high.
                  </p>
                </div>

                <div className='enhanced-feature-item'>
                  <h3 className='enhanced-feature-heading'>SIMPLIFIED MESSAGING</h3>
                  <p className='enhanced-feature-description'>
                    For external events, we've removed "Public, no tickets required" for a cleaner experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Streamlined Checkout Banner Section */}
        <div className='streamlined-checkout-section'>
          {/* Banner with image and overlay text */}
          <div className='streamlined-checkout-banner'>
            <div className='banner-image-container'>
              <img
                src={Banner4}
                alt="Streamlined Checkout Banner"
                className='streamlined-checkout-banner-img'
              />
              <div className='banner-overlay'>
                <h2 className='streamlined-checkout-title'>STREAMLINED CHECKOUT & PAYMENTS</h2>
              </div>
            </div>
          </div>
        </div>

        {/* Checkout Features Section */}
        <div className='checkout-features-section'>
          <div className='checkout-features-container'>
            {/* Centered Image */}
            <div className='checkout-features-image-container'>
              <img
                src={Image4}
                alt="Checkout Features Interface"
                className='checkout-features-image'
              />
            </div>

            {/* Bottom Text Content - Two Columns */}
            <div className='checkout-features-content'>
              <div className='checkout-feature-item left'>
                <h3 className='checkout-feature-heading'>HOUSE ACCOUNT PAYMENTS</h3>
                <p className='checkout-feature-description'>
                  Enable member transactions without a payment processor — perfect for regions without Stripe support.
                </p>
              </div>

              <div className='checkout-feature-item right'>
                <h3 className='checkout-feature-heading'>OPTIMIZED CHECKOUT</h3>
                <p className='checkout-feature-description'>
                  A redesigned flow removes delivery steps and streamlines $0 checkouts for a frictionless experience.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA Section */}
        <div className='final-cta-section'>
          <div className='final-cta-container'>
            {/* Header Text */}
            <div className='final-cta-header'>
              <h2 className='final-cta-title'>A PLATFORM FOR THE FUTURE</h2>
              <p className='final-cta-description'>
                Member Portal 3.0 is more than a feature upgrade — it's a bold step forward in digital
                hospitality. With enhanced personalization, global readiness, and a seamless experience
                from end to end, your club is positioned at the forefront of member engagement.
              </p>
            </div>

            {/* Green CTA Block */}
            <div className='final-cta-block'>
              <div className='final-cta-block-content'>
                <p className='final-cta-block-subtitle'>
                  Your members will feel the difference.<br />
                  Your team will deliver it with ease.
                </p>
                <h3 className='final-cta-block-title'>
                  NOW IS THE TIME TO ELEVATE<br />
                  YOUR MEMBER EXPERIENCE.
                </h3>
                <p className='final-cta-block-description'>
                  Contact your Account Representative today to begin your upgrade journey.
                </p>
              </div>
            </div>

            {/* Logo */}
            <div className='final-cta-logo-container'>
              <img
                src={Logo}
                alt="PeopleVine Logo"
                className='final-cta-logo'
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mobile Version */}
      <section className='member-portal-page-mobile'>
        {/* Mobile Banner */}
        <div className='mobile-banner-section'>
          <img
            src={MobileHeroBanner}
            alt="Member Portal 3.0 Mobile Hero Banner"
            className='mobile-banner-img'
          />
          <div className='mobile-banner-overlay'>
            <h1 className='mobile-banner-title'>MEMBER PORTAL 3.0</h1>
            <p className='mobile-banner-subtitle'>A NEW ERA FOR YOUR MEMBER EXPERIENCE</p>
          </div>
          <div className='mobile-banner-description'>
            <p className='mobile-description-text'>
              Welcome To Member Portal 3.0<br />
              The Foundation Of A Truly Elevated Member Journey
            </p>
            <p className='mobile-description-details'>
              More than a gateway, this reimagined platform empowers you with greater control, flexibility, and sophistication, transforming how your members discover, book, and engage with your club's world-class services and amenities.
            </p>
          </div>
        </div>

        {/* Mobile Access Section */}
        <div className='mobile-access-section'>
          <div className='mobile-access-banner'>
            <h2 className='mobile-access-title'>ACCESS MADE EFFORTLESS</h2>
            <p className='mobile-access-subtitle'>Members can now log in with Face ID – no passwords, just a glance.</p>
          </div>

          <div className='mobile-access-image'>
            <img
              src={MobileImg1}
              alt="Mobile Access"
              className='mobile-access-img'
            />
          </div>

          <div className='mobile-members-section'>
            <h3 className='mobile-section-title'>FOR MEMBERS</h3>

            <div className='mobile-feature-item'>
              <h4 className='mobile-feature-title'>RELIABLE ACCESS:</h4>
              <p className='mobile-feature-description'>
                Works seamlessly in most conditions, including low light or while wearing a mask.
              </p>
            </div>

            <div className='mobile-feature-item'>
              <h4 className='mobile-feature-title'>INSTANT ENTRY:</h4>
              <p className='mobile-feature-description'>
                Log in securely in seconds with facial recognition.
              </p>
            </div>

            <div className='mobile-feature-item'>
              <h4 className='mobile-feature-title'>ULTIMATE SECURITY:</h4>
              <p className='mobile-feature-description'>
                Biometric login means no passwords to remember or reset – your face is your key.
              </p>
            </div>
          </div>

          <div className='mobile-operators-image'>
            <img
              src={MobileImg2}
              alt="Mobile Operators"
              className='mobile-operators-img'
            />
          </div>

          <div className='mobile-operators-section'>
            <h3 className='mobile-section-title'>FOR OPERATORS</h3>

            <div className='mobile-feature-item'>
              <h4 className='mobile-feature-title'>PREMIUM EXPERIENCE:</h4>
              <p className='mobile-feature-description'>
                A sleek, intuitive login that meets the expectations of today's discerning members.
              </p>
            </div>

            <div className='mobile-feature-item'>
              <h4 className='mobile-feature-title'>REDUCED SUPPORT:</h4>
              <p className='mobile-feature-description'>
                Fewer password reset requests for your team to handle.
              </p>
            </div>

            <div className='mobile-feature-item'>
              <h4 className='mobile-feature-title'>ENHANCED PROTECTION:</h4>
              <p className='mobile-feature-description'>
                Biometric authentication delivers robust, modern security.
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Flexible Content Banner */}
        <div className='mobile-flexible-banner-section'>
          <div className='mobile-flexible-banner-image'>
            <img
              src={MobileBanner2}
              alt="Flexible Content Presentation"
              className='mobile-flexible-banner-img'
            />
          </div>
          <div className='mobile-flexible-banner-content'>
            <h2 className='mobile-flexible-banner-title'>FLEXIBLE CONTENT PRESENTATION, TAILORED TO YOUR CLUB</h2>
          </div>
        </div>

        {/* Mobile Content Section */}
        <div className='mobile-content-section'>
          <div className='mobile-content-description'>
            <p className='mobile-content-text'>
              Your club is unique, your member portal should reflect that.
            </p>
            <p className='mobile-content-details'>
              Directory Cards introduce a new content structure, giving you full control over how dining, spa, activities, and more are showcased. Curate experiences, link bookings, or embed forms, all with greater flexibility over layout and sequence.
            </p>
          </div>

          <div className='mobile-gif-container'>
            <img
              src={MobileGif1}
              alt="Mobile Content GIF"
              className='mobile-gif'
            />
          </div>

          <div className='mobile-content-features'>
            <div className='mobile-content-item'>
              <h4 className='mobile-content-feature-title'>INFORMATIONAL</h4>
              <p className='mobile-content-feature-desc'>Share static content, hours, and image galleries.</p>
            </div>

            <div className='mobile-content-item'>
              <h4 className='mobile-content-feature-title'>BOOKABLE</h4>
              <p className='mobile-content-feature-desc'>Connect members directly to one or multiple schedulers.</p>
            </div>

            <div className='mobile-content-item'>
              <h4 className='mobile-content-feature-title'>FORM</h4>
              <p className='mobile-content-feature-desc'>Enable easy enquiry submissions with a single form.</p>
            </div>

            <div className='mobile-content-item'>
              <h4 className='mobile-content-feature-title'>HYBRID</h4>
              <p className='mobile-content-feature-desc'>Combine booking and forms for multifaceted experiences.</p>
            </div>

            <div className='mobile-content-item'>
              <h4 className='mobile-content-feature-title'>CALL-TO-ACTION</h4>
              <p className='mobile-content-feature-desc'>Guide members seamlessly with internal or external links.</p>
            </div>
          </div>
        </div>

        {/* Mobile Capabilities Section */}
        <div className='mobile-capabilities-section'>
          <h2 className='mobile-capabilities-title'>NEW CAPABILITIES</h2>

          <div className='mobile-capabilities-content'>
            <div className='mobile-capability-item'>
              <h4 className='mobile-capability-title'>REDESIGNED HOME PAGE:</h4>
              <p className='mobile-capability-desc'>
                Aggregate your signature experiences like events, spa, dining and club benefits front and center on one page.
              </p>
            </div>

            <div className='mobile-capability-item'>
              <h4 className='mobile-capability-title'>DIRECTORY PRIORITIZATION:</h4>
              <p className='mobile-capability-desc'>
                Control the order of your directory profiles to highlight your most important offerings at the top.
              </p>
            </div>
          </div>

          <div className='mobile-capabilities-image'>
            <img
              src={MobileImg3}
              alt="Mobile Capabilities"
              className='mobile-capabilities-img'
            />
          </div>
        </div>

        {/* Mobile Booking Section */}
        <div className='mobile-booking-section'>
          <div className='mobile-booking-banner'>
            <h2 className='mobile-booking-title'>OPTIMIZED BOOKING & EVENT MANAGEMENT</h2>
          </div>

          <div className='mobile-booking-content'>
            <h3 className='mobile-booking-subtitle'>Fewer steps. More confirmations.</h3>
            <p className='mobile-booking-description'>
              A streamlined booking drawer makes it easier for members to select time slots, add guests, and complete reservations quickly.
            </p>
          </div>

          <div className='mobile-booking-gif'>
            <img
              src={MobileGif2}
              alt="Mobile Booking GIF"
              className='mobile-booking-gif-img'
            />
          </div>

          <div className='mobile-booking-features'>
            <div className='mobile-booking-item'>
              <h4 className='mobile-booking-feature-title'>WAITLIST VISIBILITY</h4>
              <p className='mobile-booking-feature-desc'>
                When events reach capacity, members see "Join Waitlist" instead of "Sold Out."
              </p>
            </div>

            <div className='mobile-booking-item'>
              <h4 className='mobile-booking-feature-title'>BOOK4TIME INTEGRATION</h4>
              <p className='mobile-booking-feature-desc'>
                Even when a time slot is fully booked, members can still view availability and join the waitlist – ensuring they remain engaged, even when demand is high.
              </p>
            </div>

            <div className='mobile-booking-item'>
              <h4 className='mobile-booking-feature-title'>ON-SALE DATES</h4>
              <p className='mobile-booking-feature-desc'>
                Events with future ticket releases display their on-sale date, keeping anticipation high.
              </p>
            </div>

            <div className='mobile-booking-item'>
              <h4 className='mobile-booking-feature-title'>SIMPLIFIED MESSAGING</h4>
              <p className='mobile-booking-feature-desc'>
                For external events, we've removed "Public, no tickets required" for a cleaner experience.
              </p>
            </div>
          </div>
        </div>

        {/* Mobile Streamlined Checkout Banner */}
        <div className='mobile-streamlined-banner-section'>
          <div className='mobile-streamlined-banner-image'>
            <img
              src={MobileBanner4}
              alt="Streamlined Checkout & Payments"
              className='mobile-streamlined-banner-img'
            />
          </div>
          <div className='mobile-streamlined-banner-content'>
            <h2 className='mobile-streamlined-banner-title'>STREAMLINED CHECKOUT & PAYMENTS</h2>
          </div>
        </div>

        {/* Mobile Checkout Section */}
        <div className='mobile-checkout-section'>
          <div className='mobile-checkout-banner'>
            <h2 className='mobile-checkout-title'>STREAMLINED CHECKOUT & PAYMENTS</h2>
          </div>

          <div className='mobile-checkout-image'>
            <img
              src={MobileImg4}
              alt="Mobile Checkout"
              className='mobile-checkout-img'
            />
          </div>

          <div className='mobile-checkout-features'>
            <div className='mobile-checkout-item'>
              <h4 className='mobile-checkout-feature-title'>HOUSE ACCOUNT PAYMENTS</h4>
              <p className='mobile-checkout-feature-desc'>
                Enable member transactions without a payment processor – perfect for regions without Stripe support.
              </p>
            </div>

            <div className='mobile-checkout-item'>
              <h4 className='mobile-checkout-feature-title'>OPTIMIZED CHECKOUT</h4>
              <p className='mobile-checkout-feature-desc'>
                A redesigned flow removes delivery steps and streamlines $0 checkouts for a frictionless experience.
              </p>
            </div>
          </div>
        </div>

        {/* Mobile CTA Section */}
        <div className='mobile-cta-section'>
          <h2 className='mobile-cta-title'>A PLATFORM FOR THE FUTURE</h2>
          <p className='mobile-cta-description'>
            Member Portal 3.0 is more than a feature upgrade — it's a bold step forward in digital hospitality. With enhanced personalization, global readiness, and a seamless experience from end to end, your club is positioned at the forefront of member engagement.
          </p>

          <div className='mobile-cta-block'>
            <p className='mobile-cta-block-subtitle'>
              Your members will feel the difference.<br />
              Your team will deliver it with ease.
            </p>
            <h3 className='mobile-cta-block-title'>
              NOW IS THE TIME TO ELEVATE YOUR MEMBER EXPERIENCE.
            </h3>
            <p className='mobile-cta-block-description'>
              Contact your Account Representative today to begin your upgrade journey.
            </p>
          </div>

          <div className='mobile-logo-container'>
            <img
              src={Logo}
              alt="PeopleVine Logo"
              className='mobile-logo'
            />
          </div>
        </div>
      </section>
    </DefaultLayout>
  )
}

export default MemberPortal3